
import Component from 'vue-class-component';
import {
  PilotagePracticeDetailsModel,
  PracticeDetailsModel, PracticeRequirementCandidateModel,
  PracticesClient,
  PracticesRequirementViewModel, PracticeType,
  RequirementsClient, SeafaringPracticeDetailsModel, ShipRepairPracticeDetailsModel
} from "@/api-client";
import {Prop} from "vue-property-decorator";
import RequirementSummary from "@/features/applications/components/RequirementSummary";
import PracticeShipRepairDetailsContent
  from "@/features/documents/practices/components/PracticeShipRepairDetailsContent.vue";
import PracticeSeafaringDetailsContent
  from "@/features/documents/practices/components/PracticeSeafaringDetailsContent.vue";
import PracticePilotageDetailsContent
  from "@/features/documents/practices/components/PracticePilotageDetailsContent.vue";

@Component({
  components: {
    PracticeShipRepairDetailsContent,
    PracticeSeafaringDetailsContent,
    PracticePilotageDetailsContent
  }
})
export default class PracticeRequirementSummary extends RequirementSummary {

  @Prop({required: true})
  requirement!: PracticesRequirementViewModel;

  chosenPractices: PracticeRequirementCandidateModel[] | null = null;
  chosenPracticeDetails: PracticeDetailsModel[] = [];
  
  get showIndex() {
      return this.chosenPracticeDetails.length > 1;
  }
  
  async created() {
    if (this.requirementValue) {
      this.chosenPractices = (await new RequirementsClient().chosenPractices(this.application.id, this.requirement.id)).practices;

      for (const practice of this.chosenPractices) {
        this.chosenPracticeDetails.push(await this.getDetailsModel(practice));
      }
    }
  }

  componentName(practiceDetails: PracticeDetailsModel) {
    if (practiceDetails instanceof ShipRepairPracticeDetailsModel) {
      return 'PracticeShipRepairDetailsContent';
    } else if (practiceDetails instanceof  SeafaringPracticeDetailsModel) {
      return 'PracticeSeafaringDetailsContent';
    }
    else if (practiceDetails instanceof PilotagePracticeDetailsModel) {
      return 'PracticePilotageDetailsContent';
    }

    throw 'Not implemented'
  }

  async getDetailsModel(practice: PracticeRequirementCandidateModel): Promise<PracticeDetailsModel> {
    switch (practice.type) {
      case PracticeType.ShipRepair:
        return await new PracticesClient().getShipRepair(practice.id);
      case PracticeType.Seafaring:
        return await new PracticesClient().getSeafaring(practice.id);
      case PracticeType.Pilotage:
        return await new PracticesClient().getPilotagePractice(practice.id);
      default:
        throw `Unknown practice type: ${practice.type}`
    }
  }
}
